module.exports = __webpack_public_path__ + "static/media/8-mobile.ae0632ca.jpg";